import { Card } from "@wojo/ui";
import { WeatherLocation } from "./WeatherLocation";
import { WeatherTabs } from "./WeatherTabs";
import { MonthlyWeather } from "./types";

type WeatherCardProps = {
    place: string;
    monthlyWeather: MonthlyWeather;
};

export const WeatherCard: React.FC<WeatherCardProps> = ({
    place,
    monthlyWeather,
}) => {
    return (
        <Card>
            <WeatherLocation location={place} />
            <WeatherTabs monthlyWeather={monthlyWeather} />
        </Card>
    );
};
